
import MessageText from "../../../assets/duotone/MessageText.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MessageTextIcon({ className, dataTestid = "MessageTextIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MessageText data-testid={dataTestid} className={classes} {...rest} />
  );
}
